import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Icon/check_bold",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.35419 2.64658C8.44793 2.74034 8.50058 2.86749 8.50058 3.00008C8.50058 3.13266 8.44793 3.25981 8.35419 3.35358L4.35419 7.35358C4.26043 7.44731 4.13327 7.49997 4.00069 7.49997C3.86811 7.49997 3.74096 7.44731 3.64719 7.35358L1.64719 5.35358C1.55611 5.25928 1.50572 5.13297 1.50685 5.00188C1.50799 4.87078 1.56058 4.74537 1.65328 4.65267C1.74599 4.55996 1.87139 4.50738 2.00249 4.50624C2.13359 4.5051 2.25989 4.5555 2.35419 4.64658L4.00069 6.29308L7.64719 2.64658C7.74096 2.55284 7.86811 2.50018 8.00069 2.50018C8.13327 2.50018 8.26043 2.55284 8.35419 2.64658Z",
			fill: "currentColor"
		})
	})
});
export default SvgCheck;
